// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-language-icon[data-v-333deeba]{margin-right:.5rem;margin-bottom:.5rem;cursor:pointer}", ""]);
// Exports
module.exports = exports;
